import script from "./products.vue?vue&type=script&setup=true&lang=js"
export * from "./products.vue?vue&type=script&setup=true&lang=js"

import "./products.vue?vue&type=style&index=0&id=9abbb1d0&lang=css"

const __exports__ = script;

export default __exports__